(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_archive-carousel-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
    var DESKTOP_DRAG_MAX = 150;
    var DESKTOP_DRAG_EASE = 45;
    var DESKTOP_DRAG_FIRE = 30;

    function ensure(dialog) {
      if (dialog._archiveViewer) return dialog._archiveViewer;
      var dataEl = dialog.querySelector('[data-archive-viewer-data]');
      if (!dataEl) return null;
      var products;
      try {
        products = JSON.parse(dataEl.textContent);
      } catch (err) {
        return null;
      }
      if (!products.length) return null;

      var flat = [];
      var offsets = [];
      var keyIndex = {};
      products.forEach(function (product, pi) {
        offsets.push(flat.length);
        keyIndex[product.key] = pi;
        product.images.forEach(function (unused, ii) {
          flat.push({ p: pi, i: ii });
        });
      });

      var captions = Array.prototype.slice.call(dialog.querySelectorAll('[data-viewer-caption]'));
      captions.forEach(function (caption) {
        var inner = caption.querySelector('.archive-viewer__caption-inner');
        var hasContent = false;
        if (inner) {
          Array.prototype.forEach.call(inner.children, function (el) {
            if (el.tagName !== 'STYLE') hasContent = true;
          });
        }
        caption.setAttribute('data-has-content', hasContent ? 'true' : 'false');
      });

      var viewer = {
        dialog: dialog,
        products: products,
        flat: flat,
        offsets: offsets,
        keyIndex: keyIndex,
        current: 0,
        image: dialog.querySelector('.archive-viewer__image'),
        thumbWrap: dialog.querySelector('.archive-viewer__thumbs-wrap'),
        thumbGroups: Array.prototype.slice.call(dialog.querySelectorAll('[data-viewer-thumbs]')),
        captions: captions,
        textSlot: dialog.querySelector('.archive-viewer__text-slot'),
        carousel: dialog.querySelector('[data-archive-viewer-carousel]')
      };
      dialog._archiveViewer = viewer;
      return viewer;
    }

    // Warms the browser cache with the next 2 and previous 2 photos in the
    // continuous sequence (not just each neighbouring product's first photo),
    // so quick swipes never land on an image that has not been fetched yet.
    // srcset is copied exactly from the displayed <img> so the browser picks
    // (and caches) the very same file.
    var PRELOAD_AHEAD = 2;

    function preload(viewer, flatIndex) {
      var total = viewer.flat.length;
      if (!viewer.preloaded) viewer.preloaded = {};
      for (var step = 1; step <= PRELOAD_AHEAD; step++) {
        [flatIndex + step, flatIndex - step].forEach(function (candidate) {
          var entry = viewer.flat[((candidate % total) + total) % total];
          var image = viewer.products[entry.p].images[entry.i];
          if (viewer.preloaded[image.src]) return;
          viewer.preloaded[image.src] = true;
          var probe = new Image();
          probe.srcset = image.srcset;
          probe.src = image.src;
        });
      }
    }

    function show(viewer, flatIndex, animate, fromCarousel) {
      var total = viewer.flat.length;
      var f = ((flatIndex % total) + total) % total;
      var entry = viewer.flat[f];
      var product = viewer.products[entry.p];
      var image = product.images[entry.i];
      viewer.current = f;

      if (viewer.image) {
        viewer.image.src = image.src;
        viewer.image.srcset = image.srcset;
        viewer.image.alt = image.alt;
        if (image.w) viewer.image.width = image.w;
        if (image.h) viewer.image.height = image.h;
      }

      viewer.thumbGroups.forEach(function (group, gi) {
        group.hidden = gi !== entry.p;
      });
      var activeGroup = viewer.thumbGroups[entry.p];
      if (activeGroup) {
        Array.prototype.forEach.call(activeGroup.querySelectorAll('.archive-viewer__thumb'), function (thumb, ti) {
          thumb.classList.toggle('is-active', ti === entry.i);
        });
      }
      if (viewer.thumbWrap) {
        viewer.thumbWrap.classList.toggle('is-single', product.images.length < 2);
      }

      viewer.captions.forEach(function (caption, ci) {
        caption.hidden = ci !== entry.p;
      });
      var activeCaption = viewer.captions[entry.p];
      if (viewer.textSlot) {
        viewer.textSlot.hidden = !(activeCaption && activeCaption.getAttribute('data-has-content') === 'true');
      }

      Array.prototype.forEach.call(viewer.dialog.querySelectorAll('.archive-viewer__chevron'), function (chevron) {
        chevron.hidden = total < 2;
      });

      if (!fromCarousel && viewer.carousel && viewer.carousel.archiveViewerCarousel) {
        viewer.carousel.archiveViewerCarousel.goTo(f, animate);
      }

      preload(viewer, f);
    }

    function initPreview(dialog) {
      if (!dialog.hasAttribute('open')) return;
      var viewer = ensure(dialog);
      if (!viewer) return;
      var handle = dialog.getAttribute('data-preview-handle');
      var start = 0;
      viewer.products.forEach(function (product, pi) {
        if (handle && product.handle === handle) start = viewer.offsets[pi];
      });
      show(viewer, start, false);
    }

    function initAll() {
      document.querySelectorAll('.archive-viewer').forEach(initPreview);
    }
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    if (document.readyState !== 'loading') initAll();

    // WINDOW capture phase: runs before the old popup block's document-level
    // capture listener (and before <product-card>'s own bubble listener), so
    // when this viewer owns the clicked product, stopPropagation() here means
    // the old popup never also opens. If no viewer on the page contains that
    // product (block disabled / not added), this returns without touching
    // the event and the old popup behaves exactly as before.
    window.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest && event.target.closest('[data-archive-lightbox-trigger]');
        if (!trigger) return;
        var key = trigger.getAttribute('data-archive-lightbox-trigger');
        var dialogs = document.querySelectorAll('.archive-viewer');
        var viewer = null;
        for (var d = 0; d < dialogs.length && !viewer; d++) {
          var candidate = ensure(dialogs[d]);
          if (candidate && candidate.keyIndex[key] !== undefined) viewer = candidate;
        }
        if (!viewer) return;

        event.preventDefault();
        event.stopPropagation();

        var dialog = viewer.dialog;
        if (!dialog.open) {
          dialog.showModal();
        }
        show(viewer, viewer.offsets[viewer.keyIndex[key]], false);
        if (dialog.requestFullscreen) {
          dialog.requestFullscreen().catch(function () {});
        }
      },
      true
    );

    // The mobile carousel reports a user swipe; keep desktop image, thumbs
    // and text in sync (they are hidden on phones but shown on rotation).
    document.addEventListener('archive-viewer:carousel-change', function (event) {
      var dialog = event.target.closest('.archive-viewer');
      var viewer = dialog && ensure(dialog);
      if (viewer) show(viewer, event.detail.index, false, true);
    });

    function slideDesktop(viewer, direction) {
      var img = viewer.image;
      var total = viewer.flat.length;
      if (!img || total < 2) return;
      var next = viewer.current + direction;
      var exitX = direction > 0 ? '-100%' : '100%';
      var enterX = direction > 0 ? '100%' : '-100%';
      img.style.transition = 'transform 0.25s ease';
      img.style.transform = 'translateX(' + exitX + ')';
      window.setTimeout(function () {
        show(viewer, next, false);
        img.style.transition = 'none';
        img.style.transform = 'translateX(' + enterX + ')';
        void img.offsetWidth;
        img.style.transition = 'transform 0.25s ease';
        img.style.transform = 'translateX(0)';
      }, 250);
    }

    var desktopSwipeStartX = null;
    var desktopSwipeStartY = null;
    var desktopSwipeDecided = false;
    var desktopSwipeHorizontal = false;
    var desktopSwipeImg = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var main = event.target.closest('.archive-viewer__main');
        if (!main || event.touches.length > 1) {
          desktopSwipeStartX = null;
          return;
        }
        desktopSwipeStartX = event.touches[0].clientX;
        desktopSwipeStartY = event.touches[0].clientY;
        desktopSwipeDecided = false;
        desktopSwipeHorizontal = false;
        desktopSwipeImg = main.querySelector('.archive-viewer__image');
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        if (desktopSwipeStartX === null || !event.touches[0] || !desktopSwipeImg) return;
        var dx = event.touches[0].clientX - desktopSwipeStartX;
        var dy = event.touches[0].clientY - desktopSwipeStartY;
        if (!desktopSwipeDecided) {
          desktopSwipeDecided = true;
          desktopSwipeHorizontal = Math.abs(dx) >= Math.abs(dy);
        }
        if (!desktopSwipeHorizontal) return;
        event.preventDefault();
        var nudge = (dx < 0 ? -1 : 1) * DESKTOP_DRAG_MAX * Math.tanh(Math.abs(dx) / DESKTOP_DRAG_EASE);
        desktopSwipeImg.style.transition = 'none';
        desktopSwipeImg.style.transform = 'translateX(' + nudge + 'px)';
      },
      { passive: false }
    );

    document.addEventListener('touchend', function (event) {
      var img = desktopSwipeImg;
      desktopSwipeImg = null;
      if (desktopSwipeStartX === null || !desktopSwipeHorizontal || !img) {
        desktopSwipeStartX = null;
        return;
      }
      var touch = event.changedTouches[0];
      var dx = touch ? touch.clientX - desktopSwipeStartX : 0;
      desktopSwipeStartX = null;

      var dialog = img.closest('.archive-viewer');
      var viewer = dialog && ensure(dialog);
      if (!viewer || Math.abs(dx) < DESKTOP_DRAG_FIRE || viewer.flat.length < 2) {
        img.style.transition = 'transform 0.25s ease';
        img.style.transform = 'translateX(0)';
        return;
      }
      slideDesktop(viewer, dx < 0 ? 1 : -1);
    });

    document.addEventListener('click', function (event) {
      var openDialog = event.target.closest('.archive-viewer');
      if (!openDialog || !openDialog.open) return;

      var closeBtn = event.target.closest('.archive-viewer__close');
      if (closeBtn) {
        openDialog.close();
        return;
      }

      var chevron = event.target.closest('.archive-viewer__chevron');
      if (chevron) {
        var chevronViewer = ensure(openDialog);
        if (chevronViewer) {
          slideDesktop(chevronViewer, chevron.classList.contains('archive-viewer__chevron--next') ? 1 : -1);
        }
        return;
      }

      var thumb = event.target.closest('.archive-viewer__thumb');
      if (thumb) {
        selectThumb(thumb);
        return;
      }

      var onImage = event.target.closest('.archive-viewer__image, .archive-viewer-carousel__image');
      if (!onImage) {
        openDialog.close();
      }
    });

    function selectThumb(thumb) {
      var dialog = thumb.closest('.archive-viewer');
      var group = thumb.closest('[data-viewer-thumbs]');
      var viewer = dialog && group && ensure(dialog);
      if (!viewer) return;
      var pi = parseInt(group.getAttribute('data-viewer-thumbs'), 10);
      var ti = parseInt(thumb.getAttribute('data-viewer-thumb'), 10);
      show(viewer, viewer.offsets[pi] + ti, false);
    }

    document.addEventListener('mouseover', function (event) {
      var thumb = event.target.closest('.archive-viewer__thumb');
      if (thumb) selectThumb(thumb);
    });

    var verticalSwipe = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var dialog = event.target.closest('.archive-viewer');
        if (!dialog || !dialog.open || !event.touches[0]) return;
        if (event.touches.length > 1) {
          verticalSwipe = null;
          return;
        }
        verticalSwipe = {
          dialog: dialog,
          startX: event.touches[0].clientX,
          startY: event.touches[0].clientY
        };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (event) {
        if (!verticalSwipe || !event.changedTouches[0]) return;
        if (event.touches.length > 0) {
          verticalSwipe = null;
          return;
        }
        var dx = event.changedTouches[0].clientX - verticalSwipe.startX;
        var dy = event.changedTouches[0].clientY - verticalSwipe.startY;
        var dialog = verticalSwipe.dialog;
        verticalSwipe = null;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 80) {
          dialog.close();
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (
          dialog.classList &&
          dialog.classList.contains('archive-viewer') &&
          document.fullscreenElement === dialog
        ) {
          document.exitFullscreen().catch(function () {});
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      var openDialog = document.querySelector('.archive-viewer[open]');
      if (!openDialog) return;
      if (event.key === 'Escape') {
        openDialog.close();
        return;
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        var viewer = ensure(openDialog);
        if (!viewer) return;
        event.preventDefault();
        show(viewer, viewer.current + (event.key === 'ArrowRight' ? 1 : -1), true);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_archive-image-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    function activateThumb(thumb) {
      var body = thumb.closest('.archive-lightbox__body');
      if (!body) return;
      var img = body.querySelector('.archive-lightbox__image');
      if (!img) return;
      img.src = thumb.getAttribute('data-full-src');
      img.srcset = thumb.getAttribute('data-full-srcset') || '';
      body.querySelectorAll('.archive-lightbox__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    }

    function resetDesktopThumbs(dialog) {
      var thumbs = dialog.querySelectorAll('.archive-lightbox__thumb');
      if (!thumbs.length) return;
      activateThumb(thumbs[0]);
      var img = dialog.querySelector('.archive-lightbox__image');
      if (img) {
        img.style.transition = 'none';
        img.style.transform = 'translateX(0)';
      }
    }

    var DESKTOP_DRAG_MAX = 150;
    var DESKTOP_DRAG_EASE = 45;
    var DESKTOP_DRAG_FIRE = 30;
    var desktopSwipeStartX = null;
    var desktopSwipeStartY = null;
    var desktopSwipeDecided = false;
    var desktopSwipeHorizontal = false;
    var desktopSwipeImg = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var main = event.target.closest('.archive-lightbox__main');
        if (!main || event.touches.length > 1) {
          desktopSwipeStartX = null;
          return;
        }
        desktopSwipeStartX = event.touches[0].clientX;
        desktopSwipeStartY = event.touches[0].clientY;
        desktopSwipeDecided = false;
        desktopSwipeHorizontal = false;
        desktopSwipeImg = main.querySelector('.archive-lightbox__image');
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        if (desktopSwipeStartX === null || !event.touches[0] || !desktopSwipeImg) return;
        var dx = event.touches[0].clientX - desktopSwipeStartX;
        var dy = event.touches[0].clientY - desktopSwipeStartY;
        if (!desktopSwipeDecided) {
          desktopSwipeDecided = true;
          desktopSwipeHorizontal = Math.abs(dx) >= Math.abs(dy);
        }
        if (!desktopSwipeHorizontal) return;
        event.preventDefault();
        var nudge = (dx < 0 ? -1 : 1) * DESKTOP_DRAG_MAX * Math.tanh(Math.abs(dx) / DESKTOP_DRAG_EASE);
        desktopSwipeImg.style.transition = 'none';
        desktopSwipeImg.style.transform = 'translateX(' + nudge + 'px)';
      },
      { passive: false }
    );

    document.addEventListener('touchend', function (event) {
      var img = desktopSwipeImg;
      desktopSwipeImg = null;
      if (desktopSwipeStartX === null || !desktopSwipeHorizontal || !img) {
        desktopSwipeStartX = null;
        return;
      }
      var touch = event.changedTouches[0];
      var dx = touch ? touch.clientX - desktopSwipeStartX : 0;
      desktopSwipeStartX = null;

      var main = event.target.closest('.archive-lightbox__main');
      var body = main && main.closest('.archive-lightbox__body');
      var thumbs = body ? Array.prototype.slice.call(body.querySelectorAll('.archive-lightbox__thumb')) : [];
      var activeIndex = 0;
      thumbs.forEach(function (t, i) {
        if (t.classList.contains('is-active')) activeIndex = i;
      });
      var nextIndex = dx < 0 ? activeIndex + 1 : activeIndex - 1;
      nextIndex = (nextIndex + thumbs.length) % thumbs.length;
      var hasNext = thumbs.length > 1;

      if (Math.abs(dx) < DESKTOP_DRAG_FIRE || !hasNext) {
        img.style.transition = 'transform 0.25s ease';
        img.style.transform = 'translateX(0)';
        return;
      }

      var exitX = dx < 0 ? '-100%' : '100%';
      var enterX = dx < 0 ? '100%' : '-100%';
      img.style.transition = 'transform 0.25s ease';
      img.style.transform = 'translateX(' + exitX + ')';

      window.setTimeout(function () {
        activateThumb(thumbs[nextIndex]);
        img.style.transition = 'none';
        img.style.transform = 'translateX(' + enterX + ')';
        void img.offsetWidth;
        img.style.transition = 'transform 0.25s ease';
        img.style.transform = 'translateX(0)';
      }, 250);
    });

    // CAPTURE phase, deliberately. On the homepage Archive card, the
    // trigger is a real <a> living inside Shopify's own <product-card>
    // custom element (assets/product-card.js), which attaches its own
    // navigateToProduct click listener directly on <product-card> in the
    // normal bubble phase. A bubble-phase listener here (even one on
    // document) would fire AFTER that ancestor listener already ran and
    // already navigated away, because "at target" and ancestor bubble
    // listeners resolve before an event reaches document going up. A
    // capture-phase listener on document fires FIRST, before the event
    // even reaches its target — so preventDefault()/stopPropagation() here
    // reliably wins the race everywhere this trigger is used, including
    // inside Morgue's plain <button> trigger (which has no competing
    // listener, so this is a no-op change there).
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('[data-archive-lightbox-trigger]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        var dialog = document.getElementById(trigger.getAttribute('data-archive-lightbox-trigger'));
        if (!dialog) return;
        var carouselRoot = dialog.querySelector('[data-swipe-carousel]');
        if (carouselRoot && carouselRoot.resetSwipeCarousel) {
          carouselRoot.resetSwipeCarousel();
        }
        resetDesktopThumbs(dialog);
        // Confirmed live 2026-09-29: calling showModal() on a <dialog>
        // that already has the "open" attribute set throws
        // InvalidStateError and aborts the rest of this handler — this
        // happens for whichever product is picked in "Preview this
        // product's popup" (rendered pre-open via the open attribute),
        // silently breaking its click-to-open even though every OTHER
        // product's dialog works fine. Guarding on .open first makes
        // clicking an already-open dialog a no-op instead of a thrown
        // error, without changing behavior for any closed dialog.
        if (!dialog.open) {
          dialog.showModal();
        }
        if (dialog.requestFullscreen) {
          dialog.requestFullscreen().catch(function () {});
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      var openDialog = event.target.closest('.archive-lightbox');
      if (!openDialog || !openDialog.open) return;

      var closeBtn = event.target.closest('.archive-lightbox__close');
      if (closeBtn) {
        openDialog.close();
        return;
      }

      var thumb = event.target.closest('.archive-lightbox__thumb');
      if (thumb) {
        activateThumb(thumb);
        return;
      }

      var onImage = event.target.closest('.archive-lightbox__image, .swipe-carousel__image');
      if (!onImage) {
        openDialog.close();
      }
    });

    document.addEventListener('mouseover', function (event) {
      var thumb = event.target.closest('.archive-lightbox__thumb');
      if (thumb) activateThumb(thumb);
    });

    var verticalSwipe = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var dialog = event.target.closest('.archive-lightbox');
        if (!dialog || !dialog.open || !event.touches[0]) return;
        if (event.touches.length > 1) {
          verticalSwipe = null;
          return;
        }
        var body = dialog.querySelector('.archive-lightbox__body');
        verticalSwipe = {
          dialog: dialog,
          startX: event.touches[0].clientX,
          startY: event.touches[0].clientY,
          // Confirmed live 2026-09-29: .archive-lightbox__body can now
          // genuinely scroll (the text-slot below the mobile carousel
          // overflows the first screen) — without this, ANY vertical
          // swipe over 80px closed the dialog, including the exact
          // gesture needed to scroll down and reach that text. Comparing
          // scrollTop before/after means a swipe that actually scrolled
          // the content no longer also dismisses it.
          startScrollTop: body ? body.scrollTop : 0
        };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (event) {
        if (!verticalSwipe || !event.changedTouches[0]) return;
        if (event.touches.length > 0) {
          verticalSwipe = null;
          return;
        }
        var dx = event.changedTouches[0].clientX - verticalSwipe.startX;
        var dy = event.changedTouches[0].clientY - verticalSwipe.startY;
        var dialog = verticalSwipe.dialog;
        var body = dialog.querySelector('.archive-lightbox__body');
        var scrolled = body && body.scrollTop !== verticalSwipe.startScrollTop;
        verticalSwipe = null;
        if (!scrolled && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 80) {
          dialog.close();
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (
          dialog.classList &&
          dialog.classList.contains('archive-lightbox') &&
          document.fullscreenElement === dialog
        ) {
          document.exitFullscreen().catch(function () {});
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDialog = document.querySelector('.archive-lightbox[open]');
      if (openDialog) openDialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
